<template>
  <div class="home-container">
    <el-carousel :interval="5000" arrow="always">
      <el-carousel-item v-for="item in 2" :key="item">
        <!-- <h3>{{ item }}</h3> -->
      </el-carousel-item>
    </el-carousel>
    <!-- 信息展示 -->
    <div class="box-shadow-container">
      <div class="info-container">
        <div class="left">
          <div class="info-title">实验室简介 INTRODUCTION</div>
          <div>
            <p class="para">
              知识图谱与类脑智能实验室(Knowledge Graph and
              Brain-inspiredIntelligence
              Laboratory,KGLab)隶属于杭州电子科技大学计算机学院。<span
                class="red-tag"
                >实验室负责人为徐小良教授</span
              >，现拥有教师6名、博士/硕士研究生共计30余名。实验室主要研究方向包括：<span
                class="red-tag"
                >大数据知识图谱、自然语言处理、图计算、异构网络社区查询、向量数据库、AIGC、多模态学习</span
              >等。
            </p>
            <p class="para">
              实验室承担和参与多项国家基金项目、省部级重点研发项目、军工项目和产学研合作项目，与国内外高校、科研机构在知识图谱、人工智能方向进行科研合作和研究生培养，近年来在CCF
              A/B类推荐会议/期刊上发表高水平论文40余篇，包括:
              <span class="red-tag"
                >SIGMOD、VLDB、ICDE、CIKM、ICPP、DASFAA、TKDD、TCDS、DKE、KBS、JCST、JOCS、DPD、CCPE</span
              >等，申请发明专利20余项，曾获浙江省科技进步奖三等奖一项。团队成员长期担任<span
                class="red-tag"
                >TKDD 、TKDE、KBS, Information Science</span
              >等多个国际SCI期刊审稿专家、担任CCF A类国际会议<span
                class="red-tag"
                >IJCAI，KDD的PC member</span
              >，并与多名国内外知名学者、研究小组保持学术交流与合作。
            </p>
              
            <p class="para">
              实验室重视理论研究与实践应用紧密结合，与<span class="red-tag"
                >华为、阿里巴巴、之江实验室、杭州三汇、中国空分、易思维科技</span
              >等行业领先科技公司、科研机构建立紧密合作关系，共同承担多项科研项目研发，建有校企联合实验室。
            </p>
          </div>
          <div class="info-title">加入我们 JOIN US</div>
          <div class="para-div">
            <div>
              <span class="black-dot">·</span>
              <span class="red-tag"
                >诚聘知识图谱、自然语言处理、大数据等方向教师、研究人员！</span
              >[<a
                href="https://renshi.hdu.edu.cn/2021/0316/c2933a132991/page.htm"
                target="__blank"
                >人才政策</a
              >][<router-link to="/joinus">详细信息</router-link>]
            </div>
            <div>
              <span class="black-dot">·</span>
              欢迎优秀本科生/硕士生报考本实验室的硕士/博士研究生！
            </div>
            <div>
              <span class="black-dot">·</span>
              实验室的毕业生就业于阿里巴巴、字节跳动、腾讯、网易、美团、华为等IT公司！
            </div>
            <div>
              <span class="black-dot">·</span>
              实验室可推荐优秀的本科生、研究生到国内外顶级研究团队进行访学或进修！
            </div>
          </div>
        </div>

        <div class="right">
          <div class="info-title">最新信息 NEWS</div>

          <div class="para-div">
            <div class="black-dot">2026.2</div>
            <div>
              实验室论文“ Through the Lens of Hubness: A Revisit on Graph-Based Approximate Nearest Neighbor Search”<span
                class="red-tag"
                >被数据库领域 CCF A类会议SIGMOD2026录用，</span
              >论文系统性揭示了hubness是图基近似最近邻搜索长尾延迟的根本原因，并提出一种hubness-aware优化来缓解拓扑失衡问题！
            </div>
            <div class="split-line"></div>
          </div>

          <div class="para-div">
            <div class="black-dot">2025.2</div>
            <div>
              <!-- <span
                class="red-tag">2篇论文</span> -->
              实验室论文“ Cohesiveness-aware Hierarchical Compressed Index for Community Search over Attributed Graphs”<span
                class="red-tag"
                >被数据库领域 CCF A类会议SIGMOD2025录用，</span
              >论文提出一个同时刻画结构凝聚性和属性相似性的分层近邻索引，在不改变原有算法框架的前提下显著加速属性图上的社区搜索！
            </div>
            <div class="split-line"></div>
          </div>

          <div class="para-div">
            <div class="black-dot">2025.1</div>
            <div>
              实验室论文“ A Comprehensive Survey and Experimental Study of Learning-based Community Search”<span
                class="red-tag"
                >被数据库领域 CCF A类会议VLDB2025录用，</span
              >提出首个学习型社区搜索方法的系统性综述与实验研究！
            </div>
            <div class="split-line"></div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style scoped>
.home-container {
  min-height: 100vh;
  /* padding-top: 60px; */
}
p {
  font-weight: bold;
  font-size: 16px;
}
.split-line {
  height: 1px;
  width: 75%;
  border-block: 1px solid #d4cfcf;
  margin: 20px auto;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n + 1) {
  background: url("https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/cropped-UDXBWS63M9_117NX.png")
    center center;
  background-size: cover;
}

.el-carousel__item:nth-child(2n) {
  background: url("https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/home2.png")
    center center;
  background-size: cover;
}
.box-shadow-container {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  margin-bottom: 100px;
}
.info-container {
  width: 80%;
  margin: 30px auto;
  display: flex;
  font-family: Microsoft YaHei;
}
.black-dot {
  color: #000;
}
.para-div > div {
  font-weight: bold;
  margin-bottom: 4px;
}
.left {
  width: 71%;
  padding-right: 28px;
}
.right {
  width: 29%;
}
.info-title {
  font-size: 40px;
  font-weight: 300;
  margin-top: 32px;
  color: #333;
  margin-bottom: 20px;
}
.info-container {
  font-size: 16px;
  padding-bottom: 40px;
}
@media screen and (max-width: 900px) {
  .info-container {
    display: block;
    width: 95%;
  }
  .left {
    width: 100%;
    padding: 0;
  }
  .right {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/index.vue